import { createAction, props } from '@ngrx/store';
import { Log, PaginatedLogs } from '@app/modules/shared/models';

enum ELogActions {
  LogsList = '[Logs] Logs List',
  LogsListSuccess = '[Logs] Logs List Success',
  LogsListError = '[Logs] Logs List Error',
  LogsListPaginated = '[Logs] Logs List Paginated',
  LogsListPaginatedSuccess = '[Logs] Logs List Paginated Success',
  LogsListPaginatedError = '[Logs] Logs List Paginated Error',
  LogGet = '[Logs] Log Get',
  LogGetSuccess = '[Logs] Log Get Success',
  LogGetError = '[Logs] Log Get Error',
  LogDelete = '[Logs] Log Delete',
  LogDeleteSuccess = '[Logs] Log Delete Success',
  LogDeleteError = '[Logs] Log Delete Error',
  ResetLogsState = '[Logs] Reset Logs State',
}

export const LogsList = createAction(ELogActions.LogsList);
export const LogsListSuccess = createAction(ELogActions.LogsListSuccess, props<{ logs: Log[] }>());
export const LogsListError = createAction(ELogActions.LogsListError, props<{ error: string }>());

export const LogsListPaginated = createAction(ELogActions.LogsListPaginated, (params: any = {}) => params);
export const LogsListPaginatedSuccess = createAction(ELogActions.LogsListPaginatedSuccess, props<{ paginatedLogs: PaginatedLogs }>());
export const LogsListPaginatedError = createAction(ELogActions.LogsListPaginatedError, props<{ error: string }>());

export const LogGet = createAction(ELogActions.LogGet, props<{ logId: number }>());
export const LogGetSuccess = createAction(ELogActions.LogGetSuccess, props<{ log: Log }>());
export const LogGetError = createAction(ELogActions.LogGetError, props<{ error: string }>());

export const LogDelete = createAction(ELogActions.LogDelete, props<{ logId: number }>());
export const LogDeleteSuccess = createAction(ELogActions.LogDeleteSuccess, props<{ success: string }>());
export const LogDeleteError = createAction(ELogActions.LogDeleteError, props<{ error: string }>());

export const ResetLogsState = createAction(ELogActions.ResetLogsState, props<{ params: Partial<ILogsState> }>());

import { ILogsState } from './logs.state';
